import { QueryResult } from "react-query";
import { isArray } from "util";

// import { getError } from "../core/errors";

interface IProps<T> {
  asyncData: QueryResult<T>;
  renderError?: (message: string) => JSX.Element;
  renderLoading?: JSX.Element;
  renderSuccess?: (data: T) => JSX.Element;
  renderEmpty?: JSX.Element;
}

export function Async<T>({ asyncData, renderError, renderLoading, renderEmpty, renderSuccess }: IProps<T>) {
  const { status, data, error } = asyncData;
  const errorMessage = error?.message;

  if (errorMessage) {
    return renderError?.(errorMessage) ?? null;
  }

  if (status === "loading") {
    return renderLoading ?? null;
  }

  if (data === undefined || (status === "success" && isArray(data) && data.length === 0)) {
    return renderEmpty ?? null;
  }

  return renderSuccess?.(data) ?? null;
}
